import { render, staticRenderFns } from "./header-account-button.vue?vue&type=template&id=7c6c7426&scoped=true"
import script from "./header-account-button.vue?vue&type=script&lang=js"
export * from "./header-account-button.vue?vue&type=script&lang=js"
import style0 from "./header-account-button.vue?vue&type=style&index=0&id=7c6c7426&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c6c7426",
  null
  
)

export default component.exports